import React, { useMemo, Fragment } from 'react';
// PROD-2739 This file can be deleted when Valere goes live 1/1/25
function Circle({ filled, colored }: { filled: boolean, colored: boolean }) {
  const background = useMemo(() => {
    if (!filled) return 'transparent';
    if (colored) return 'var(--w-s-color-background-secondary)';
    return 'var(--w-s-color-background-disabled)';
  }, [colored, filled]);

  const border = `4px solid ${colored ? 'var(--w-s-color-background-secondary)' : 'var(--w-s-color-background-disabled)'}`;

  return (
    <div
      className="min-w-[26px]  h-[26px] relative rounded-full"
      style={{
        background,
        border,
      }}
    />
  );
}

function Connector(props: { colored: boolean }) {
  return (
    <div
      className="w-[14.29px] h-4 relative"
      style={{
        background: props.colored ? 'var(--w-s-color-background-secondary)' : 'var(--w-s-color-background-disabled',
      }}
    />
  );
}

type ProgressBarProps = {
  totalSteps: number,
  currentStep: number,
};

export default function ProgressBar({ totalSteps, currentStep }: ProgressBarProps) {
  return (
    <div className="items-center inline-flex max-w-full overflow-x-auto">
      {[...Array(totalSteps)].map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={i}>
          <Circle filled={i < currentStep} colored={i <= currentStep} />
          {i < totalSteps - 1 && <Connector colored={i < currentStep} />}
        </Fragment>
      ))}
    </div>
  );
}
